import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=0618f6be"
import script from "./payment?vue&type=script&lang=js&external"
export * from "./payment?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports